/* Pouch stamps. wallet-preview.js puts the stamp where every wallet has it, at the bottom right (the logo, with the
   stamp text above it). On the Pouch it is the other way round: the stamping text goes in the middle of the flap's
   lip (on the drawing where the lip is out), and the logo goes at the bottom right of both drawings. This script moves
   them after each paint. It only runs on the Pouch's artwork, so no other product is touched. Distances are in inches
   of the real wallet. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pp-preview]');
  if (!root || !/pp-pouch/i.test(root.getAttribute('data-svg') || '')) return;
  var svg = root.querySelector('[data-pp-svg]'), art = root.querySelector('[data-pp-art]');
  if (!svg || !art) return;
  var C = window.PPConfig || {}, L = (C.layouts || {})[root.getAttribute('data-layout')] || {};
  var S = {
    piece: 'panel', /* the stamping text goes on the piece with this data-role (the flap); the first one in the artwork is the drawing with the lip out */
    at: 0.86,       /* how far down that piece: 0 is its top edge, 1 its bottom edge (the middle of the lip) */
    up: 0,          /* then nudged up this far (0 = not at all; it sat 0.1 higher before) */
    down: 0.1       /* the logo sits this much lower than on other wallets, so the edge of the lip clears it on the drawing where the lip is out */
  };

  function fix(g) {
    var upi = (svg.__artw || 0) / (L.inches || 6);
    if (!(upi > 0) || g.__pouch) return;
    g.__pouch = 1;
    var logo = [].filter.call(g.children, function (n) { return n.tagName === 'g'; })[0],
      texts = [].slice.call(g.querySelectorAll('text')), t = texts[texts.length - 1], hi = texts.length > 1 ? texts[0] : null,
      ch = t ? (parseFloat(t.getAttribute('font-size')) || 0) * 0.7 : 0,
      inv = g.getCTM().inverse(),
      pt = function (p, x, y) { return new DOMPoint(x, y).matrixTransform(inv.multiply(p.getCTM())); };

    /* the stamping text: the middle of the flap's lip, on the drawing where the lip is out */
    var flap = art.querySelector('path[data-role="' + S.piece + '"]');
    if (t && ch && flap) {
      var b = flap.getBBox(), a = pt(flap, b.x, b.y), z = pt(flap, b.x + b.width, b.y + b.height),
        cx = (a.x + z.x) / 2, base = a.y + (z.y - a.y) * S.at - S.up * upi + ch / 2;
      [t, hi].forEach(function (n) {
        if (!n) return;
        n.setAttribute('text-anchor', 'middle');
        n.setAttribute('x', cx + (n === hi ? 0.35 : 0)); n.setAttribute('y', base + (n === hi ? 0.55 : 0));
      });
    }

    /* the logo: the engine already put it at the bottom right of the lower drawing; lower it a little, then copy it to the
       same spot on the other drawing's body, by the distance between the two bodies' bottom edges */
    var mv = logo && /translate\(([-\d.e]+)[ ,]+([-\d.e]+)\)/.exec(logo.getAttribute('transform') || '');
    if (mv) logo.setAttribute('transform', logo.getAttribute('transform').replace(mv[0],
      'translate(' + mv[1] + ' ' + (parseFloat(mv[2]) + S.down * upi) + ')'));
    var backs = art.querySelectorAll('path[data-role="back"]');
    if (!logo || backs.length < 2) return;
    var foot = function (p) { var bb = p.getBBox(); return pt(p, bb.x + bb.width / 2, bb.y + bb.height); },
      from = foot(backs[backs.length - 1]), to = foot(backs[0]), c = logo.cloneNode(true);
    [].forEach.call(c.querySelectorAll('[id]'), function (n) { n.removeAttribute('id'); });
    c.removeAttribute('id');
    c.setAttribute('transform', 'translate(' + (to.x - from.x) + ' ' + (to.y - from.y) + ') ' + (logo.getAttribute('transform') || ''));
    g.appendChild(c);
  }

  new MutationObserver(function (list) {
    list.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1 && n.classList.contains('pp-logo')) fix(n); });
    });
  }).observe(art, { childList: true, subtree: true });
  [].forEach.call(art.querySelectorAll('.pp-logo'), fix);
})();
